<div class="row">
  <div class="text-center offset-lg-2 col-lg-8 mb-2 mb-md-0">
    @if (title(); as title) {
      <h2 class="generic-products-section__heading" *scText="title"></h2>
    }
    @if (content(); as content) {
      <wl-rich-text-wrapper [field]="content">
        <div class="generic-products-section__content"></div>
      </wl-rich-text-wrapper>
    }
  </div>
</div>

@if (rendering(); as rendering) {
  <sc-placeholder
    name="generic-products-section-dynamic"
    [rendering]="rendering"
  />
}
